import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import IconExternalLink from "@amzn/stencil-react-icons/icons/icon-external-link";
import { INFO_CARD_BORDER_COLOR } from "@/common/types/constants";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React, { FunctionComponent } from "react";

export const HardwareUpgradeInfoCard: FunctionComponent = () => (
  <Card
    data-testid="hardware-upgrade-banner"
    style={{ border: `1px solid ${INFO_CARD_BORDER_COLOR}` }}
    backgroundColor="primary05"
  >
    <Col gridGap="S200">
      <View flex={2}>
        <Text fontSize="T300" fontWeight="bold" color="neutral90">
          {getString("hardwareUpgradeCard.title")}
        </Text>
      </View>

      <Row display="flex">
        <View flex={2}>
          <Text
            style={{ whiteSpace: "pre-line" }}
            fontSize="T200"
            fontWeight="regular"
            color="neutral90"
            lineHeight="24px"
          >
            {getString("hardwareUpgradeCard.description")}
            <Link href={getString("hardwareUpgradeCard.linkUrl")} target="_blank" icon={<IconExternalLink />}>
              {getString("hardwareUpgradeCard.linkText")}
            </Link>
          </Text>
        </View>

        <View flex={1} display="flex" justifyContent="center" alignItems="flex-start" width="100%" height="100%">
          <div className="dog-icon" />
        </View>
      </Row>
    </Col>
  </Card>
);
